<template>
  <div>
    <ul class="f-list flex">
      <li v-for="(item,key) in list" :key="key" class="center">
        <div class="tx-center">
          <img src="../../assets/img/device/tr_waterbeng.png" alt="" />
          <div class="mt10">{{ item.name }}</div>
          <div class="align-center mt10">
            <span>手自动</span>
            <el-switch class="ml20" disabled v-model="item.shouzidong" active-text="手动" inactive-text="自动"> </el-switch>
          </div>
          <div class="align-center mt10">
            <span>启停：</span>
            <!-- <el-input class="ml10 flex1" size="mini" v-model="item.v_video_address"></el-input> -->
            <el-switch class="ml20" v-model="item.qiting" disabled active-text="启用" inactive-text="停止"> </el-switch>
          </div>
          <div class="align-center mt10">
            <span>电源：</span>
            <!-- <el-input class="ml10 flex1" size="mini" v-model="item.v_video_address"></el-input> -->
            <el-switch class="ml20" v-model="item.zhudian" disabled active-text="异常" inactive-text="正常"> </el-switch>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getwaterbeng } from "../../api/facility.js";
export default {
  data() {
    return {
      list: [],
      value1: false,
      value2: false,
      value3: true,
    };
  },
  created() {},
  mounted() {
    if (this.cpNum) this.getList();
  },

  props: ["cpNum"],
  watch: {
    cpNum() {
      this.getList();
    },
  },
  methods: {
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "fe559562bb2b456b848a545bb5d2eb4a" : this.cpNum;

      getwaterbeng({ c_company_num: cNum }).then((res) => {
        var arr = [];
        if (!res.data.length) {
          this.$message.warning("该业务尚未开通，请联系管理员");
          return;
        }
        if (res.data) {
          arr = res.data;
        } else {
          arr.push({ value: 2 });
        }
        var arr2 = [];
        arr.map((item) => {
          item.qiting = item.qiting ? (Number(item.qiting) ? true : false) : false;
          item.shouzidong = item.shouzidong ? (Number(item.shouzidong) ? true : false) : false;
          item.zhudian = item.zhudian ? (Number(item.zhudian) ? true : false) : false;
          arr2.push(item);
        });
        this.list = arr2;
        console.log(this.list);
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
